let reloading = false;

export function isReloadingWindow(): boolean {
  return reloading;
}

export default function reloadWindow(): void {
  reloading = true;
  window.location.reload();
}
